// polyfill webpack require.ensure
if (typeof require.ensure !== 'function') require.ensure = function (deps, cbFn) {
  return cbFn(require);
};
export default (function () {
  return {
    path: 'rd',
    getComponent: function getComponent(location, callback) {
      require.ensure([], function (require) {
        callback(null, require('containers/MarketingRedirect/MarketingRedirect').MarketingRedirect);
      }, 'mkt-redirect');
    }
  };
});